import type { ReactNode } from 'react';
import type { AdminUser } from '../lib/types';

interface AdminLayoutProps {
  children: ReactNode;
  currentPath: string;
  user: AdminUser;
  onLogout: () => void;
}

const adminLinks = [
  { href: '/admin', label: 'Dashboard' },
  { href: '/admin/pages', label: 'Pages' },
  { href: '/admin/nav', label: 'Navigation' },
  { href: '/admin/profiles', label: 'Profiles' },
  { href: '/admin/social', label: 'Social Links' },
  { href: '/admin/users', label: 'Users' },
  { href: '/admin/contact', label: 'Contact' },
  { href: '/admin/audit', label: 'Audit' },
  { href: '/admin/gallery', label: 'Gallery' },
  { href: '/admin/files', label: 'Files' }
];

export function AdminLayout({ children, currentPath, user, onLogout }: AdminLayoutProps) {
  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <a className="admin-brand" href="/admin">Lawrenceville 131</a>
        <nav aria-label="Admin navigation">
          {adminLinks.map((link) => (
            <a
              aria-current={isActive(currentPath, link.href) ? 'page' : undefined}
              href={link.href}
              key={link.href}
            >
              {link.label}
            </a>
          ))}
        </nav>
      </aside>
      <div className="admin-workspace">
        <header className="admin-topbar">
          <div>
            <strong>{user.displayName}</strong>
            <span>{user.role}</span>
          </div>
          <button type="button" onClick={onLogout}>Sign out</button>
        </header>
        <main className="admin-main">{children}</main>
      </div>
    </div>
  );
}

function isActive(currentPath: string, href: string): boolean {
  if (href === '/admin') {
    return currentPath === '/admin';
  }

  return currentPath.startsWith(href);
}
